import { useMemo } from 'react'

import useAxios from 'hooks/useAxios'

/** @returns {Option<Extra>[] | null} */
export default function useCustomAttributeOptions() {
  /**
   * @typedef Data
   * @property {string} field
   * @property {string} label
   * @property {string} key
   */

  /**
   * @typedef Prop
   * @property {Data[]} data
   * @property {function} fetch
   */

  /** @type {Prop} */
  // @ts-ignore
  const { data } = useAxios({
    url: 'reports/preload-advanced-filters/',
  })

  // @ts-ignore
  return useMemo(() => {
    if (!data) {
      return null
    }
    return data
      .filter((entry) => entry.key === 'customer.attribute' || entry.key === 'ticket.attribute')
      .map((attribute) => ({
        field: attribute.key,
        label: attribute.label,
        icon: 'fas fa-exchange-alt',
        comparison: 'is',
        extra: {
          attribute: attribute.field,
        },
      }))
  }, [data])
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useCustomAttributeOptions/index.js